/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Select_Ad_FailedInputs */

const en_audio_embed_export_select_ad_failed = /** @type {(inputs: Audio_Embed_Export_Select_Ad_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error selecting AD audio file`)
};

const fr_audio_embed_export_select_ad_failed = /** @type {(inputs: Audio_Embed_Export_Select_Ad_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la sélection du fichier audio AD`)
};

const de_audio_embed_export_select_ad_failed = /** @type {(inputs: Audio_Embed_Export_Select_Ad_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler bei der Auswahl der AD-Audiodatei`)
};

const it_audio_embed_export_select_ad_failed = /** @type {(inputs: Audio_Embed_Export_Select_Ad_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante la selezione del file audio AD`)
};

const ru_audio_embed_export_select_ad_failed = /** @type {(inputs: Audio_Embed_Export_Select_Ad_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при выборе аудиофайла AD`)
};

const es_audio_embed_export_select_ad_failed = /** @type {(inputs: Audio_Embed_Export_Select_Ad_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al seleccionar el archivo de audio AD`)
};

const zh_cn2_audio_embed_export_select_ad_failed = /** @type {(inputs: Audio_Embed_Export_Select_Ad_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择 AD 音频文件时出错`)
};

const ja_audio_embed_export_select_ad_failed = /** @type {(inputs: Audio_Embed_Export_Select_Ad_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADオーディオファイルの選択エラー`)
};

const hi_audio_embed_export_select_ad_failed = /** @type {(inputs: Audio_Embed_Export_Select_Ad_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD ऑडियो फ़ाइल का चयन करने में त्रुटि`)
};

const pt_pt2_audio_embed_export_select_ad_failed = /** @type {(inputs: Audio_Embed_Export_Select_Ad_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao selecionar o arquivo de áudio AD`)
};

/**
* | output |
* | --- |
* | "Error selecting AD audio file" |
*
* @param {Audio_Embed_Export_Select_Ad_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_select_ad_failed = /** @type {((inputs?: Audio_Embed_Export_Select_Ad_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Select_Ad_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_select_ad_failed(inputs)
	if (locale === "de") return de_audio_embed_export_select_ad_failed(inputs)
	if (locale === "it") return it_audio_embed_export_select_ad_failed(inputs)
	if (locale === "ru") return ru_audio_embed_export_select_ad_failed(inputs)
	if (locale === "es") return es_audio_embed_export_select_ad_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_select_ad_failed(inputs)
	if (locale === "ja") return ja_audio_embed_export_select_ad_failed(inputs)
	if (locale === "hi") return hi_audio_embed_export_select_ad_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_select_ad_failed(inputs)
	return en_audio_embed_export_select_ad_failed(inputs)
});